const getMarketingConsent = () => {
  if (!window.Cookiebot) {
    return true
  }
  return window.Cookiebot.consent.marketing
}

export { getMarketingConsent }
